/**
 * 回傳網站內有使用到的各種網址
 *
 * @returns { privacyPolicyUrl: string, trainingUrl: string, technicalUrl: string, resourceUrl: string }
 */

export function useWebsiteUrl() {
  const { $i18n } = useNuxtApp();
  const { locale } = $i18n;

  // 根據不同語系取得 Privacy Policy 的網址

  const privacyPolicyUrl = computed((): string => {
    switch (locale.value) {
      case EnumLocale.ZH_TW:
        return 'https://www.advantech.tw/legal/privacy';
      case EnumLocale.JA_JP:
        return 'https://www.advantech.co.jp/legal/privacy';
      case EnumLocale.EN_KR:
        return 'https://www.advantech.co.kr/legal/privacy';
      case EnumLocale.ZH_CN:
        return 'https://www.advantech.com.cn/zh-cn/legal/privacy';
      default:
        return 'https://www.advantech.com/legal/privacy';
    }
  });

  // 根據不同語系取得 Training（培訓與認證）的網址

  const trainingUrl = computed((): string => {
    switch (locale.value) {
      case EnumLocale.ZH_CN:
        return 'https://training.advantech.com.cn';
      default:
        return 'https://learn.advantech.com/training';
    }
  });

  // 根據不同語系取得 Technical（專業技術文件）的網址

  const technicalUrl = computed((): string => {
    switch (locale.value) {
      case EnumLocale.ZH_TW:
        return 'https://docs.wise-paas.advantech.com/zh-tw';
      case EnumLocale.JA_JP:
        return 'https://docs.wise-paas.advantech.com/ja';
      default:
        return 'https://docs.wise-paas.advantech.com/en';
    }
  });

  // 根據不同語系取得 ResourceUrl（行銷資源）的網址

  const resourceUrl = computed((): string => {
    switch (locale.value) {
      case EnumLocale.ZH_TW:
        return 'https://www.advantech.com.tw/zh-tw/resources?others=wise-paas';
      case EnumLocale.ZH_CN:
        return 'https://www.advantech.com.cn/zh-cn/resources?others=wise-paas';
      case EnumLocale.JA_JP:
        return 'https://www.advantech.com/ja-jp/resources?others=wise-paas';
      default:
        return 'https://www.advantech.com/en/resources?others=wise-paas';
    }
  });

  return { privacyPolicyUrl, trainingUrl, technicalUrl, resourceUrl };
}
